export function tap<T>(value: T, callable?: ((value: T) => void)): T {
    if (callable) {
        callable(value);
    }

    return value;
}
